import React from 'react';

import styled from 'styled-components';

import { LinkButton } from '@adsk/alloy-react-button';
import Dropdown, {
  MultiAutocompleteTokenControl,
} from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';
import theme from '@adsk/alloy-react-theme';

export const StyledPackagesFilter = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${theme.colors.charcoal200};
`;

export const StyledPackagesFilterHeader = styled.div`
  display: flex;
  font-weight: 700;
  margin-bottom: 16px;
`;

export const StyledPackagesFilterResetButton = styled(LinkButton)`
  font-size: 12px;
  margin-left: 8px;
  visibility: ${(props) => props.$hidden && 'hidden'};
`;

export const StyledPackagesFilterBody = styled.div``;

export const StyledFormField = styled(FormField).attrs({
  labelVariant: FormField.LABEL_VARIANTS.TOP,
  style: { marginBottom: 16 },
})``;

export const StyledDropdown = styled(Dropdown).attrs({
  isMultiple: true,
  isAutocomplete: true,
  style: { width: '100%' },
  getFilteredItems: ({ allItems, itemToString, inputValue }) => {
    if (!inputValue) {
      return allItems;
    }

    return allItems?.filter((item) =>
      [item.label, item.subtext].some((label) => {
        return itemToString({ label })
          .toLowerCase()
          .includes(inputValue.toLowerCase());
      }),
    );
  },
  renderControl: (props) => <MultiAutocompleteTokenControl {...props} />,
})``;
